import React from 'react';
import './TabStatusIndicator.css';

/**
 * TabStatusIndicator - Shows completion status for report tabs
 * @param {string} status - 'complete' (green), 'not-started' (amber), or 'incomplete' (red)
 * @param {string} label - The tab label text
 */
const TabStatusIndicator = ({ status, label }) => {
  const getStatusClass = () => {
    switch (status) {
      case 'complete':
        return 'tab-status-complete';
      case 'not-started':
        return 'tab-status-not-started';
      case 'incomplete':
        return 'tab-status-incomplete';
      default:
        return 'tab-status-not-started';
    }
  };

  return (
    <div className={`tab-status-indicator ${getStatusClass()}`}>
      {label}
    </div>
  );
};

export default TabStatusIndicator;
